import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

/**
 * An in-application link with the link color that passes contrast in both modes.
 */
export function TextLink({ to, children }: { to: string; children: ReactNode }) {
	return (
		<Link to={to} className="text-link underline underline-offset-4 hover:no-underline">
			{children}
		</Link>
	);
}
